/**
 * Current embedded preview version. Increment for non-breaking changes
 * to inform the user that an update is available.
 */
export const embeddedPreviewVersion = "0.1.1";

/**
 * Minimum compatible embedded preview version. Increment (along with
 * embeddedPreviewVersion) to force the user to update before using
 * the embedded previewer.
 *
 * 0.0.8 — `isEmbeddedState` now delegates to `isBuilderHost` from
 * `@intelligems/ig-embedded-preview` so it returns true on visual-builder
 * cookie-isolation subdomains (`<target_underscored>.<main>`), not just
 * the bare main hosts. Older plugins return false there and skip
 * embedded-preview init, which breaks the visual builder whenever an
 * upstream cross-origin redirect lands the iframe on a cookie-isolation
 * host.
 */
export const minEmbeddedPreviewVersion = "0.1.1";
